<template>
	<div class="freitext-container">
		<h2 v-if="title" v-html="title"></h2>
		<txt @add:response="addResponse" v-for="item in items" :key="item.id" :item="item" />
	</div>
</template>

<script>
import txt from "@/components/items/txt.vue";

export default {
	name: "txt-block",
	components: {
		txt,
	},
	props: {
		items: Array,
		title: String,
	},
	methods: {
		addResponse(response) {
			this.$emit("add:response", response);
		},
	},
};
</script>

<style scoped>
h2 {
	font-size: 1.1rem;
	font-weight: 600;
	margin: 1rem 0 0.4rem 0;
}
.freitext-container {
	width: 100%;
}
</style>
